module.exports = __webpack_public_path__ + "flyer_background_coals_two_043-cf8fdd1d5b749875a7016b07860766e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_coals_two_043.jpg
// module id = 1625
// module chunks = 1